exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-platform[data-v-407265df] {\n  margin: 0 -15px;\n  /*background-size: cover;*/\n  background-size: 100% auto;\n  background-position: center top;\n  padding-bottom: 70px;\n}\n.page-platform .section-listGame[data-v-407265df] {\n  margin: 0 0 16px;\n}", ""]);

// exports
